import { validatePresence } from 'ember-changeset-validations/validators';
import checkDate from 'volta/validators/check-date';

export default {
  comment: [validatePresence(true)],
  dueDate: [checkDate({ isIsoFormat: true, isNotInPast: true, allowEmpty: true })]
};
